import { render, staticRenderFns } from "./2FAInput.vue?vue&type=template&id=5a469edb&scoped=true&"
import script from "./2FAInput.vue?vue&type=script&lang=js&"
export * from "./2FAInput.vue?vue&type=script&lang=js&"
import style0 from "./2FAInput.vue?vue&type=style&index=0&id=5a469edb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a469edb",
  null
  
)

export default component.exports